import { render, staticRenderFns } from "./CrearClienteView.vue?vue&type=template&id=34e4f670&"
import script from "./CrearClienteView.vue?vue&type=script&lang=js&"
export * from "./CrearClienteView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports